module.exports = __webpack_public_path__ + "img/t2-8.90896da3.jpg";